<template>
  <div class="baixar-pdf-wrapper">
    <!-- O botão original só aparece se NÃO estivermos no modo de personalização -->
    <button v-if="!exportando" ref="exportButton" @click="iniciarExportacao">
      {{ label }}
    </button>

    <!-- O construtor interativo é montado quando a exportação é iniciada -->
    <ConstruirPdf
      v-if="exportando"
      :colegiado="colegiado"
      :mandatos="mandatos"
      :selected-orgao="selectedOrgao"
      :filename="filename"
      :orientation="orientation"
      @cancelar="finalizarExportacao"
      @concluido="finalizarExportacao"
    />
  </div>
</template>

<script>
import ConstruirPdf from './ConstruirPdf.vue'

export default {
  name: 'BaixarPdf',
  components: {
    ConstruirPdf
  },
  props: {
    colegiado: {
      type: Object,
      default: null,
    },
    mandatos: {
      type: Array,
      default: () => [],
    },
    selectedOrgao: {
      type: Object,
      default: null,
    },
    filename: {
      type: String,
      default: 'colegiado.pdf',
    },
    label: {
      type: String,
      default: 'Baixar PDF',
    },
    orientation: {
      type: String,
      default: 'portrait',
    }
  },
  data() {
    return {
      exportando: false,
      observadorDeTamanho: null
    }
  },
  watch: {
    $route() {
      this.finalizarExportacao()
    }
  },
  methods: {
    iniciarExportacao() {
      this.exportando = true

      // document.body.style.overflow = 'hidden'
      
      const style = document.createElement('style')
      style.id = 'pdf-hide-original-layout'
      style.textContent = `
        /* O wrapper agora se fixa no topo absoluto da tela (viewport) cobrindo tudo */
        .baixar-pdf-wrapper {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 100vw !important;
          height: 100vh !important;
          display: flex !important;
          align-items: flex-start !important;
          justify-content: center !important;
          z-index: 9999 !important; /* Fica por cima de qualquer menu ou cabeçalho */
          margin: 0 !important;
          padding: 3rem 1rem !important; /* Espaçamento confortável nas bordas */
          box-sizing: border-box !important;
          background: rgba(0, 0, 0, 0.45) !important; /* Escurece 100% da tela */
          backdrop-filter: blur(4px) !important; /* Efeito de desfoque profissional */
          overflow-y: auto !important; /* ROLAGEM ÚNICA: A rolagem acontece suavemente apenas aqui */
        }

        .construir-pdf {
          width: min(1400px, calc(100vw - 2rem)) !important;
          max-width: 1400px !important;
          margin: 0 auto !important;
          position: relative !important;
          z-index: 10000 !important;
          background: #ffffff !important;
          border-radius: 0.5rem !important;
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4) !important; /* Sombra suave e profunda */
        }

        .construir-pdf,
        .construir-pdf .config-panel {
          min-height: 0 !important;
          height: auto !important;
          flex: none !important;
        }
      `
      document.head.appendChild(style)
    },
    finalizarExportacao() {
      this.exportando = false
      const style = document.getElementById('pdf-hide-original-layout')
      if (style && document.head.contains(style)) {
        document.head.removeChild(style)
      }
    }
  },
  deactivated() {
    this.finalizarExportacao()
  },
  beforeDestroy() {
    this.finalizarExportacao()
  }
}
</script>

<style scoped>
.baixar-pdf-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

button {
  color: #efefef;
  text-decoration: none;
  font-family: "Montserrat-Medium";
  border: #005516 solid 0.15rem;
  padding: 0.3rem 2rem;
  border-radius: 0.2rem;
  transition: 0.2s;
  background-color: #005516;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 0;
  line-height: 1.2;
  box-sizing: border-box;
}

button:hover {
  color: white;
  background-color: #4CAF50;
}

button i {
  font-size: 1rem;
}
</style>
